export class ImprovementsLayout {
	public sections = [
		{
			title: 'General Structure',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementStructureStatus'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAttachmentType'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementUnits'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementStoriesCount'
						}
					},
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementDesignStyle'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementPropertyBuiltYear'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEffectiveAgeDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeGLA',
							displayType: 'gla'
						}
					},
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementTotalRoomCount'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeBedrooms'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeFullBathrooms'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGradeHalfBathrooms'
						}
					},
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVFunctionalUtility'
						}
					}
				]
			]
		},
		{
			title: 'Attic / Foundation / Basement',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'multi-rows',
						fields: [
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAtticExists',
										displayType: 'bool'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAtticAccess'
									}
								}
							]
						]
					},
					{
						cssClass: 'col-md-4',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Attic Characteristics',
									colSpan: 2
								},
							],
							rows: [
								{
									cols: [
										{
											options: { label: 'Floor' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAtticCharacteristicsFloor',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Finished' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAtticCharacteristicsFinished',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Heated' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAtticCharacteristicsHeated',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
							]
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Foundation Type',
									colSpan: 2
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Concrete Slab' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFoundationTypeConcreteSlab',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Crawlspace' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFoundationTypeCrawlspace',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Partial Basement' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFoundationTypePartialBasement',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Full Basement' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFoundationTypeBasement',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Foundation has evidence of',
									colSpan: 2
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Infestation' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementConditionDampness',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Dampness' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementConditionInfestation',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Settlement' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementConditionSettlement',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'multi-rows',
						fields: [
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHasSumpPump',
										displayType: 'bool'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHasOutSideAccess',
										displayType: 'bool'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementBasementSquareFootage',
										displayType: 'gla'
									}
								}
							]
						]
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'multi-rows',
						fields: [
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementBasementFinishedIndicator',
										displayType: 'bool'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementBasementFinishedPercent',
										displayType: 'percentage'
									}
								}
							]
						]
					},
					{
						cssClass: 'col-md-4',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Finished Basement Rooms Count',
									colSpan: 2
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Bedrooms' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVBasementFinishedBedrooms',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Full Bathrooms' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVBasementFinishedFullBathrooms',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Half Bathrooms' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVBasementFinishedHalfBathrooms',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Recreation Rooms' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVBasementRecreationRooms',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Other Rooms' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVBasementOtherRooms',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Heating & Cooling',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Type of Cooling',
									colSpan: 2
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Central A/C' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingCentralized',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Individual' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingIndividual',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Other' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingOther',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCoolingDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Type of Heating',
									colSpan: 2
								}
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Forced Warm Air' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHeatingForcedWarmAir',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Hot Water Baseboard' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHeatingHotWaterBaseboard',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Radiant' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHeatingRadiant',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementHeatingFuelType'
						}
					}
				]
			]
		},
		{
			title: 'Appliances',
			items: [
				[
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentRefrigerator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentRangeOven',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentDishwasher',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentDisposal',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentMicrowave',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-2',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentWasherDryer',
							displayType: 'bool'
						}
					},
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentOther',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementEquipmentOtherDescription'
						}
					},
				]
			]
		},
		{
			title: 'Amenities',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Amenity'},
								{ label: 'Exists?' },
								{ label: 'How Many?' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Fireplaces' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFireplace',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFireplaceCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Woodstoves' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityWoodStove',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityWoodStoveCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Amenity'},
								{ label: 'Exists?' },
								{ label: 'Description' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Fence' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFence',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityFenceDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Patio/Deck' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPatio',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPatioDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Porch' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPorch',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPorchDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Pool' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPool',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityPoolDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Other' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityOther',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityOtherDescription',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAmenityComments'
						}
					}
				]
			]
		},
		{
			title: 'Car Storage',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'multi-rows',
						fields: [
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageIndicator',
										displayType: 'bool'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageDrivewaySurface'
									}
								}
							],
							[
								{
									type: 'field',
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageGarageType'
									}
								}
							]
						]
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Type'},
								{ label: 'Exists?' },
								{ label: 'Parking Spaces' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Driveway' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageDrivewayIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageDrivewayCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Garage' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageGarageIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageGarageCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Carport' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageCarportIndicator',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementCarStorageCarportCount',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Features',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Item'},
								{ label: 'Material & Condition' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Foundation Wall' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFoundationMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Exterior Walls' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementExteriorWallsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Roof Surface' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementRoofSurfaceMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Gutters/Downspouts' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementGuttersAndDownspoutsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Window Type' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementWindowTypeMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Storm Sash/Insulated' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementWindowStormSashMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Screens' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementScreensMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Item'},
								{ label: 'Material & Condition' },
							],
							rows: [
								{
									cols: [
										{ 
											options: { label: 'Floors' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementFloorsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Walls' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorWallsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Trim/Finish' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorTrimAndFinishMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Bath Floor' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorBathroomFloorsMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: { label: 'Bath Wainscot' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementInteriorBathroomWainscotMaterial',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Conditions',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVStructureQualityOfConstruction',
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[CVRank=\'0\'].CVStructureCondition',
						}
					},
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVUpdateLastFifteenYear',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{ label: 'Area'},
								{ label: 'Improvements' },
								{ label: 'Date' },
							],
							rows: [
								{
									cols: [
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType1',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType1DescriptionType',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType1EstimateYearOf',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType2',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType2DescriptionType',
												show: {
													value: true,
													label: false
												}
											}
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVImprovementAreaType2EstimateYearOf',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
							]
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyPhysicalDeficiency',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyPhysicalDeficiencyDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyConditionComment'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVConformsToNeighborhood',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-8',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVConformsToNeighborhoodDescription'
						}
					}
				]
			]
		},
		{
			title: 'PUD Information',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPUDIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVDeveloperControlsProjectManagementIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPUDUnitTypes'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectName'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectTotalPhasesCount'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectTotalUnitsCount'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectUnitsSoldCount'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectUnitsRentedCount'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectUnitsForSaleCount'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectDataSource'
						}
					}
				],
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectConversionOfExistingPUD',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectConversionDate'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectMultipleDwellingUnitsIndicator',
							displayType: 'bool'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsCompletedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsStatusDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsLeasedIndicator',
							displayType: 'bool'
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsLeaseTermsDescription'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVProjectCommonElementsDescription',
							displayType: 'bool'
						}
					}
				]
			]
		}
	];
}